import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import httpClient from "../../../custom-hooks/httpClient";

function InitiateTransfer({
  handleInitiateTransfer,
  handleChangeTransferDetails,
  user,
  transferDetails,
  setTransferDetails,
}) {
  const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const [serviceProviders, setServiceProviders] = useState([]);
  const [isValidating, setIsValidating] = useState(false);

  const handleVerifyMeterNo = () => {
    setIsValidating(true);
    httpClient
      .post(`/payments/categories/electricity/verify-meter`, {
        meter_number:
          REACT_APP_ENVIRONMENT === "dev"
            ? "04042404048"
            : transferDetails.meter_number,
        service_type: transferDetails.service_type,
      })
      // { headers: { "Content-type": "application/json" }}
      .then(({ status, data }) => {
        setIsValidating(false);
        if (status === 200) {
          setTransferDetails({
            ...transferDetails,
            account_details: `${data.meter.name} | ${data.meter.address}`,
          });
        }
      })
      .catch((err) => {
        setIsValidating(false);
        console.log(err);
        toast.error(
          err.response.data.message || "Error verifying account number"
        );
      });
  };

  useEffect(() => {
    const { transaction_pin, ...fields } = transferDetails;
    Object.values(fields).includes("") ? setAreFieldsSet(false) : setAreFieldsSet(true);
  }, [transferDetails]);

  useEffect(() => {
    httpClient
      .post(`/payments/categories/electricity/get-service-types`, {})
      // { headers: { "Content-type": "application/json" } }
      .then(({ status, data }) => {
        if (status === 200) {
          setServiceProviders(data.serviceTypes);
        }
      })
      .catch((err) => {
        toast.error(
          err.response.data.message || "Error getting service providers"
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h2 className="mb-5 text-primary fw-bold">Initiate Electricity Purchase</h2>
      <div className="card shadow h-100 py-2">
        <div className="card-body">
          <h3 className="card-title text-muted">Purchase Electricity</h3>
          <form onSubmit={handleInitiateTransfer}>
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="walletAccountNumber">
                From Wallet
              </label>
              <select
                className="form-control"
                name="wallet_account_number"
                id="walletAccountNumber"
                onChange={handleChangeTransferDetails}
              >
                <option value="">--Select Wallet--</option>
                {/* Exclude Savings wallet as it is not a transactable */}
                {user.wallets
                  .filter((wallet) => wallet.type !== "savings")
                  .map((wallet) => (
                    <option value={wallet.account_no} key={wallet.id}>
                      {wallet.name} (&#8358;
                      {Number(wallet.balance).toFixed(2).toLocaleString()})
                    </option>
                  ))}
              </select>
            </div>

            <div className="form-group mb-3">
              <label className="form-label" htmlFor="serviceType">
                Service Provider
              </label>
              <select
                className="form-control"
                name="service_type"
                id="serviceType"
                onChange={handleChangeTransferDetails}
              >
                <option value="">--Select Service Provider--</option>
                {serviceProviders.map((provider) => (
                  <option
                    value={provider.service_type}
                    key={provider.product_id}
                  >
                    {provider.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mb-3">
              <label className="form-label" htmlFor="meterNumber">
                Meter Number
              </label>

              <input
                name="meter_number"
                id="meterNumber"
                type="text"
                className="form-control"
                placeholder="Meter number"
                title="Numbers only"
                maxLength="20"
                required
                onChange={handleChangeTransferDetails}
              />
              <div className="mt-2">
                {isValidating ? (
                  <span className="btn btn-primary-soft w-50">
                    <Loader
                      type="Oval"
                      color="#1c743a"
                      width={20}
                      height={20}
                    />
                  </span>
                ) : (
                  <span
                    className="btn btn-primary-soft w-50"
                    onClick={handleVerifyMeterNo}
                  >
                    Validate Meter Number
                  </span>
                )}
              </div>
            </div>
            <div className="form-group mb-3">
              <input
                className="form-control"
                type="text"
                // value={accountName}
                value={transferDetails.account_details}
                // readOnly
                disabled
              />
            </div>
            <div className="form-group mb-5">
              <label className="form-label" htmlFor="transferAmount">
                Amount &#8358;
              </label>

              <input
                name="amount"
                id="transferAmount"
                type="number"
                className="form-control"
                placeholder=""
                title="Numbers only"
                maxLength="10"
                required
                onChange={handleChangeTransferDetails}
                step="0.01" // Accommodate for decimal values
                onWheel={(e) => e.target.blur()} //Disable scrolling
              />
            </div>
            <div className="form-group mb-5">
              <label className="form-label" htmlFor="phoneNumber">
                Phone Number
              </label>
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">+234</span>
                </div>
                <input
                  type="tel"
                  className="form-control"
                  onChange={handleChangeTransferDetails}
                  name="phone_number"
                  title="Numbers only, e.g. 08023456789"
                  maxLength="11"
                  required
                  // value={phoneNumber}
                  pattern="0[0-9]{10}"
                  id="phoneNumber"
                  placeholder="08123456789"
                />
              </div>
            </div>
            {/* <div className="form-group mb-5">
              <label className="form-label" htmlFor="phone_number">
                Phone number
              </label>

              <input
                name="narration"
                id="narration"
                type="text"
                className="form-control"
                placeholder="Enter phone number"
                maxLength="30"
                onChange={handleChangeTransferDetails}
              />
            </div> */}
            <button
              type="submit"
              className="btn w-100 btn-primary"
              disabled={!areFieldsSet}
            >
              Proceed
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default InitiateTransfer;
